import { createSlice } from '@reduxjs/toolkit';
import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';
const applicationSlice = createSlice({
    name: 'application',
    initialState: {
        originalApplicationValues: {},
        codes: {}
    },
    reducers: {
        setOriginalApplicationValues: (state, action) => {
            state.originalApplicationValues = action.payload;                     
        },
        setApplication: (state, action) => {
            state = cloneDeep(action.payload);
            return state;
        },        
        setApplicationPageCompletedStatus: (state, action) => {
            const { pageId, complete } = action.payload;
            if (state.pageStatuses[pageId] !== complete) {
                state.pageStatuses[pageId] = complete;
            }
        },
        setApplicationValue: (state, action) => {
            set(state, action.payload.name, action.payload.value);
        },
        setStatus: (state, action) => {
            state.status = action.payload;
        },
        setCode: (state, action) => {
            const { path, code } = action.payload;
            state.codes = state.codes || {};
            set(state.codes, path, code);

            return state;
        },
        setCurriculumRules: (state, action) => {
            state.curriculumRules = action.payload;

            return state;
        },
        setCurriculumValues: (state, action) => {
            state.curriculumValues = action.payload;

            return state;
        }
    },
});
export const selectCurriculumValues = state => state.application?.curriculumValues;
export const {
    setApplication,
    setApplicationPageCompletedStatus,
    setApplicationValue,
    setOriginalApplicationValues,    
    setStatus,
    setCode,
    setCurriculumRules,
    setCurriculumValues
} = applicationSlice.actions;
export default applicationSlice.reducer;
